export default __webpack_public_path__ + "static/media/logo-light.e5c68e90.svg";